import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../SearchBar";

const AiChatbot = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      fetchStockData();
    } else {
      setResults([]);
    }
  }, [debouncedSearchTerm]);

  const fetchStockData = useCallback(async () => {
    if (!debouncedSearchTerm) return;

    setLoading(true);
    try {
      const API_URL = `${process.env.REACT_APP_API_URL}/api/stocks?query=${debouncedSearchTerm}`;
      console.log(API_URL)
      const response = await fetch(API_URL);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setResults(data.results || []);
    } catch (error) {
      console.error("Error fetching stock data:", error);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStockClick = (stock) => {
    console.log(stock);
    navigate(`stock/${stock.SCRIP_NAME}`, { state: { stock } });

  };

  return (
    <div className="stock-analyzer-container">
      <header className="stock-analyzer-header">
        <h1>Swing Algo</h1>
        <p className="subtitle">A Journey Worth Taking</p>
      </header>

      <SearchBar
        placeholder="Search for stocks by name or symbol..."
        value={searchTerm}
        onChange={handleSearchChange}
        loading={loading}
      />

      <div className="results-container">
        {results.length > 0 ? (
          <div className="stock-results">
            {results.map((result, index) => (
              <div
                key={index}
                className="stock-card"
                onClick={() => handleStockClick(result)}
                role="button"
                tabIndex={0}
              >
                <h3>{result.SCRIP_NAME}</h3>
                <p className="company-name">{result.COMPNAME}</p>
              </div>
            ))}
          </div>
        ) : debouncedSearchTerm ? (
          <div className="no-results">
            No results found. Try a different search term.
          </div>
        ) : (
          <div className="initial-state">
            <p>Enter a stock name or symbol to begin your analysis</p>
          </div>
        )}
      </div>

    </div>
  );
};

export default AiChatbot;
